import { render, staticRenderFns } from "./settings-fee-schedule.vue?vue&type=template&id=4c2e1cc0&scoped=true&"
import script from "./settings-fee-schedule.vue?vue&type=script&lang=js&"
export * from "./settings-fee-schedule.vue?vue&type=script&lang=js&"
import style0 from "./settings-fee-schedule.vue?vue&type=style&index=0&id=4c2e1cc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2e1cc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c2e1cc0')) {
      api.createRecord('4c2e1cc0', component.options)
    } else {
      api.reload('4c2e1cc0', component.options)
    }
    module.hot.accept("./settings-fee-schedule.vue?vue&type=template&id=4c2e1cc0&scoped=true&", function () {
      api.rerender('4c2e1cc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/settings/settings-fee-schedule.vue"
export default component.exports